import styled from "styled-components"
import WegetCollectedSidebar from "../weget-collected-sidebar/weget-collected-sidebar"

const StyledContainer = styled.div`
  display: flex;
  min-height: 100vh;
`

const MainContent = styled.main`
  flex: 1;
  overflow-y: auto;
`

const WegetCollectedLayout = ({ sidebarItems, children }) => {

  return (
    <StyledContainer>
      <WegetCollectedSidebar />
      <MainContent>{children}</MainContent>
    </StyledContainer>
  )
}

export default WegetCollectedLayout

